function setCookie(key, value) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}

jQuery(function($){
  var $nl_html = $('#newsletter-popup-html');
  var $popupOpen = false;

   $(document).on('click', function(event) { 
     if($popupOpen==false && $nl_html.length && getCookie('hide_newsletter_popup')!=1){
       event.preventDefault();
       openNewsletterPopup();
     }
   });
   $(document).on('mousemove', function(event) {
     openNewsletterPopup();
   });
    $(window).on('scroll', function() {
      openNewsletterPopup();
    });
    $(window).on('resize', function() {
      openNewsletterPopup();      
    });

  function openNewsletterPopup(){
    if($popupOpen==false && $nl_html.length && getCookie('hide_newsletter_popup')!=1){
      $popupOpen = true;
      $('body').append('<div class="newsletter_popup popup-overlay">'+ $nl_html.html() +'</div>');
      $('.newsletter_popup').fadeIn('3000');
    }
  }

  $(document).on("click","a.newsletter_popup_close",function() {
    $('.newsletter_popup').fadeOut('3000');
    setCookie('hide_newsletter_popup','1');
    return false;
  });



  /* bomber club js codes - below */

  function equalizeHeights(selector) {
    const elements = $(selector);
    let maxHeight = 0;

    elements.css('height', 'auto'); // Reset previous heights

    elements.each(function () {
        maxHeight = Math.max(maxHeight, $(this).height());
    });

    elements.height(maxHeight);
  }
  
  function handleEqualHeights() {
      if ($(window).width() > 575) {
          equalizeHeights('.img-col-desc .text-1');
          equalizeHeights('.img-col-desc .text-2');
          equalizeHeights('.img-col-desc .text-3');
          equalizeHeights('.ski-selection-form .card-information__text');
      } else {
          $('.img-col-desc .text-1, .img-col-desc .text-2, .img-col-desc .text-3,.ski-selection-form .card-information__text').css('height', 'auto');
      }
  }

  handleEqualHeights();
  $(window).on('resize', function () {
      handleEqualHeights();
  });

  $('.has-hover-banner .multicolumn-list__item').hover(function () {
    var $this = $(this);
    if ($this.hasClass('active')) return;
    
    var targetId = $this.data('target-banner');
    $('.icon-banner-img').stop(true, true).fadeOut(200);
  
    $('#' + targetId).stop(true, true).fadeIn(300);
    $('.has-hover-banner .multicolumn-list__item').removeClass('active');
    $this.addClass('active');
  });


  $(document).on("click",".card-selectable",function() {
    var $me = $(this);
    $(".card-selectable").removeClass('is-selected');
    $me.addClass('is-selected');
    $('#selected_ski').val( $me.data('product-title'));
    $('#selected_ski_handle').val( $me.data('product-handle'));
  });

  $('#save-club-plan').on('click', function (e) {
    e.preventDefault();

    $('#MainContent').addClass('loading');
    
    var formData = $('#form-plan-reservation').serialize();
    $('.error-msg-wrap').html('');
    $('.success-msg-wrap').html('');
    $('.messages-wrap').hide();

    $.ajax({
      url: 'https://demo-projects.com/shopify_apps/BomberClubDev/save_club_plan.php',
      type: 'POST',
      data: formData,
      dataType: 'json',
      success: function (response) {
        if (response.status === 'error') {
          $('.error-msg-wrap').html(response.message);
        } else if (response.status === 'success') {
          $('.success-msg-wrap').html(response.message);
          window.location = $('#form-plan-reservation').data('redirect_url');
        } else {
          $('.error-msg-wrap').html('<p>Unexpected response from server.</p>');
        }
        $('.messages-wrap').fadeIn('fast');
        $('#MainContent').removeClass('loading');
        $('html, body').animate({
            scrollTop: $('.messages-wrap').offset().top - 100
        }, 600)
      },
      error: function (xhr, status, error) {
        $('#MainContent').removeClass('loading');
        $('.error-msg-wrap').html('<p>Error saving data. Please try again later.</p>');
      }
    });
  });

  /* if($('#save-ski-selection').length > 0){
    var $_html = $('#bomberclub-success-popup-html');
      $('body').append('<div class="bomberclub-success_popup popup-overlay">'+ $_html.html() +'</div>');
      $('.bomberclub-success_popup').fadeIn('3000');
  }*/


  $('#save-ski-selection').on('click', function (e) {
    e.preventDefault();
    $('#MainContent').addClass('loading');
    
    var formData = $('#form-ski-selection').serialize();
    $('.error-msg-wrap').html('');
    $('.success-msg-wrap').html('');
    $('.messages-wrap').hide();

    $.ajax({
      url: 'https://demo-projects.com/shopify_apps/BomberClubDev/save_ski_selection.php',
      type: 'POST',
      data: formData,
      dataType: 'json',
      success: function (response) {
        if (response.status === 'error') {
          $('.error-msg-wrap').html(response.message);
        } else if (response.status === 'success') {

          //open popup
          $('body').append('<div class="bomberclub-success_popup popup-overlay">'+ $('#bomberclub-success-popup-html').html() +'</div>');
          $('.bomberclub-success_popup').fadeIn('3000');

          //$('.success-msg-wrap').html(response.message);
          //window.location = $('#form-ski-selection').data('redirect_url');
        } else {
          $('.error-msg-wrap').html('<p>Unexpected response from server.</p>');
        }
        $('#MainContent').removeClass('loading');
        $('.messages-wrap').fadeIn('fast');
        $('html, body').animate({
            scrollTop: $('.messages-wrap').offset().top - 100
        }, 600);
        
      },
      error: function (xhr, status, error) {
        $('#MainContent').removeClass('loading');
          $('.error-msg-wrap').html('<p>Error saving data. Please try again later.</p>');
      }
    });
  });
  
});

function checkLimitedCartProducts(adding_to_cart){
  var limited_products = $('.limited-product');
  var cart_count = parseInt($('#cart-icon-bubble span:last-child').text());
  if(limited_products.length && cart_count > 0 && $('body').hasClass('template-cart')){
    $.ajax({
        type: 'GET',url: '/cart',dataType: 'json',async: false,
        success: function(cart) {
          for (var i = 0; i < cart.items.length; i++) {
            limited_products.each(function(){
              var limited_product_elem = $(this);
              var limited_product_handle = $(this).data('limited-product');
              if (cart.items[i].handle === limited_product_handle) {
                var can_remove_limit_product = true;
                var limit_to_products = limited_product_elem.find('.limit-to-product');
                if(limit_to_products.length){
                  limit_to_products.each(function(){
                    for (var j = 0; j < cart.items.length; j++) {
                      var limit_to_product_handle = $(this).data('limit-to-product');
                      if (cart.items[j].handle === limit_to_product_handle) {
                        can_remove_limit_product = false;
                        break;
                      }                 
                    }
                  });
                }
                if(can_remove_limit_product == true){
                  $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data: {id: cart.items[i].id,quantity: 0},
                    dataType: 'json',
                    success: function(cart) {
                      if($('body').hasClass('template-cart')){
                        window.location.reload();
                      }
                      reloadCarts();
                      //disableCheckoutButton();
                    },
                    error: function(error) {
                      reloadCarts();
                      //disableCheckoutButton();
                    }
                  });
                }
              }
            });
          }
        },
        error: function(xhr, status, error) {
            console.error('Limit check failed. Error fetching cart: ' + error);
        }
    });
  }
  setTimeout(function(){
    checkLimitedCartProducts(false);
  },3000);
}
function reloadCarts(){
  $('#cart-icon-bubble').load(location.href + " #cart-icon-bubble");
}

checkLimitedCartProducts(false);


$(document).on("click",".accordion-item .accordion-title",function() {
  $(this).parent().stop(true).toggleClass('open');
  $(this).parent().find('.accordion-desc').stop(true).slideToggle('fast');
});

$(".testimonial-slider").slick({
  infinite: true,
  slidesToShow: 3,
  autoplay: true,
  autoplaySpeed: 5000,
  responsive: [
    { breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    { breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    },
    { breakpoint: 575,
      settings: {
        slidesToShow: 1
      }
    }]
})